import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authModule } from '../../api/modules/auth.module';
import { showToast } from '../../utils/toast';
import { ForgetPasswordView } from './ForgetPassword.view';

/**
 * Forgot password, the container. The reset request, the toasts, the routing.
 *
 * Everything visual lives in `ForgetPassword.view.jsx`, which is pure, so the
 * state explorer can mount both states of the real screen without any of this
 * running.
 *
 * `ForgetPassword.css` is deleted with this conversion. Nothing else imported
 * it, so the file is gone rather than orphaned. The hand-rolled
 * `LoadingSpinner` in the submit is gone too: `AuthSubmit` owns the busy state.
 */

export default function ForgetPassword() {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    setLoading(true);
    setSubmitting(true);

    try {
      const result = await authModule.requestPasswordResetOtp({
        email: values.email,
      });

      if (result.success) {
        setUserEmail(values.email);
        setEmailSent(true);
        showToast.success(result.message || 'Password reset link sent to your email');
      } else {
        showToast.error(result.error || 'Failed to send reset link');
        if (result.error?.toLowerCase().includes('email')) {
          setFieldError('email', result.error);
        }
      }
    } catch (error) {
      showToast.error('Something went wrong. Please try again.');
      console.error('Password reset request error:', error);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <ForgetPasswordView
      onSubmit={handleSubmit}
      onBackToLogin={handleBackToLogin}
      loading={loading}
      sent={emailSent}
      sentEmail={userEmail}
    />
  );
}